module.exports = __webpack_public_path__ + "img/internet.060ea263.svg";